import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { getCurrencyPrice } from '@/checkout-instore-legacy/utils/ProductUtils'
import IntlMessage from './IntlMessage'

type Props = { pricePerUnit: number; intl: any }
const UnitPrice: FC<Props> = ({ pricePerUnit, intl }) => {
  const formattedPrice = getCurrencyPrice(pricePerUnit, intl)

  return (
    <div className="t-small-ns t-mini-s c-muted-2 mv3-s mt2-ns">
      <FormattedMessage
        {...IntlMessage.unitPrice}
        values={{ price: formattedPrice }}
      />
    </div>
  )
}

export default UnitPrice
